import { useContext } from 'react';
import {
  DialogTitle,
  DialogContent,
  DialogActions,
  Alert,
} from '@mui/material';
import { NotasContext } from 'contexts/NotasContext';
import { useModal } from 'components/Modals';
import Button from 'components/Button';

const ExpedicaoModal = ({ onSubmit }) => {
  const { closeModal } = useModal();
  const { postLoading } = useContext(NotasContext);

  return (
    <>
      <DialogTitle>Liberar Expedição</DialogTitle>
      <DialogContent>
        <Alert severity="warning">
          Deseja realmente liberar a expedição de TODOS os documentos filtrados?
        </Alert>
      </DialogContent>
      <DialogActions>
        <Button onClick={onSubmit} loading={postLoading}>
          Confirmar
        </Button>
        <Button onClick={closeModal} color="secondary">
          Cancelar
        </Button>
      </DialogActions>
    </>
  );
};

export default ExpedicaoModal;
